import type { FC } from 'react';
import { useEffect, useState } from 'react';

import * as Sentry from '@sentry/react';
import { useHistory } from 'react-router';

import { Skeleton } from 'src/app/components/Elements/Skeleton';
import { useExchangeForFullUrl } from 'src/app/hooks/data/pharmacyHub';
import { useIsSpanishRoute } from 'src/app/hooks/useIsSpanishRoute';
import { clearRxSelect, spanishClearRxSelect } from 'src/app/router/paths';

import { HubInvalidCode } from './HubInvalidCode';

interface WithPharmakonRedirectProps {
  match: { params: { hash: string } };
}
export const ClearRxShortCodeRedirect: FC<WithPharmakonRedirectProps> = props => {
  const isSpanishRoute = useIsSpanishRoute();
  const [hasLongURLError, setHasLongURLError] = useState(false);
  const shortUrlHash = props?.match?.params?.hash;
  const { status, data } = useExchangeForFullUrl(shortUrlHash);
  const history = useHistory();

  useEffect(() => {
    if (shortUrlHash && status !== 'loading') {
      if (data && data.longURL) {
        const longUrl = new URL(data.longURL);
        if (isSpanishRoute) {
          history.push(spanishClearRxSelect.route + longUrl.search);
        } else {
          history.push(clearRxSelect.route + longUrl.search);
        }
      } else if (status === 'error') {
        setHasLongURLError(true);
        Sentry.captureException('Error getting pharmacy hub full url', {
          contexts: {
            request: {
              shortUrlHash: shortUrlHash,
            },
          },
        });
      }
    }
  }, [shortUrlHash, data, status]);

  if (hasLongURLError) {
    return HubInvalidCode();
  }

  return <Skeleton />;
};
